export function BladeMark({ className = "h-8 w-8", spin = false }) {
  return (
    <svg viewBox="-32 -32 64 64" className={className} aria-hidden="true">
      <g className={spin ? "animate-spin-slow origin-center" : ""} style={{ transformBox: "fill-box" }}>
        <path
          fill="#E5A93C"
          d="M0-27l4 5 6-3 2 6 7-1-1 7 6 2-3 6 5 4-5 4 3 6-6 2 1 7-7-1-2 6-6-3-4 5-4-5-6 3-2-6-7 1 1-7-6-2 3-6-5-4 5-4-3-6 6-2-1-7 7 1 2-6 6 3z"
        />
        <circle r="16" fill="#0A0A0C" />
      </g>
      <path fill="#D4E60A" d="M4-14L-8 3h7l-4 12L9-3H2z" />
    </svg>
  );
}

export function BigBlade({ className = "" }) {
  const teeth = Array.from({ length: 36 });
  return (
    <svg viewBox="-100 -100 200 200" className={className} aria-hidden="true">
      <circle r="92" fill="none" stroke="#E5A93C" strokeOpacity="0.35" strokeWidth="0.6" />
      <circle r="70" fill="none" stroke="#E5A93C" strokeOpacity="0.18" strokeWidth="0.6" strokeDasharray="2 4" />
      <circle r="30" fill="none" stroke="#D4E60A" strokeOpacity="0.4" strokeWidth="0.6" />
      {teeth.map((_, i) => (
        <path
          key={i}
          transform={`rotate(${i * 10})`}
          d="M0 -92 L5 -99 L7 -92 Z"
          fill="#E5A93C"
          fillOpacity="0.55"
        />
      ))}
    </svg>
  );
}
